import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function Comparison() {
  return <section className="py-10 sm:py-14 bg-charcoal relative" data-id="element-45">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-46">
        <div className="text-center mb-7 sm:mb-10" data-id="element-47">
          <div className="text-gold tracking-[0.2em] uppercase text-xs sm:text-sm mb-4" data-id="element-48">
            A New Paradigm
          </div>
          <h2 className="font-serif text-3xl sm:text-5xl text-ivory" data-id="element-49">
            Why This Works Differently
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-12" data-id="element-50">
          {/* UNHOOKED Column */}
          <div className="bg-teal-dark/30 border border-teal/50 rounded-xl p-6 sm:p-10 relative overflow-hidden" data-id="element-51">
            <div className="absolute top-0 left-0 w-full h-1 bg-gold/60" data-id="element-52" />
            <h3 className="font-serif text-2xl sm:text-3xl text-ivory mb-6 sm:mb-8 break-words text-center sm:text-left" data-id="element-53">
              UNHOOKED
            </h3>
            <ul className="space-y-6" data-id="element-54">
              {['Removes desire at the root', 'Focuses on dopamine understanding', 'No streak obsession', 'No shame-based motivation', 'Calm psychological framework', 'Brain rewiring approach'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-55">
                  <div className="mt-1 bg-teal/40 rounded-full p-1" data-id="element-56">
                    <CheckIcon className="w-4 h-4 text-gold" data-id="element-57" />
                  </div>
                  <span className="text-ivory/90 text-lg font-light" data-id="element-58">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Traditional Column */}
          <div className="bg-charcoal-light border border-charcoal-lighter rounded-xl p-6 sm:p-10" data-id="element-59">
            <h3 className="font-serif text-2xl sm:text-3xl text-ivory/50 mb-6 sm:mb-8 break-words text-center sm:text-left" data-id="element-60">
              Traditional Methods
            </h3>
            <ul className="space-y-6" data-id="element-61">
              {['Depend on willpower', 'Create guilt cycles', 'Focus only on resisting urges', 'Make relapse feel catastrophic', 'Increase mental exhaustion'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-62">
                  <div className="mt-1 bg-charcoal rounded-full p-1" data-id="element-63">
                    <XIcon className="w-4 h-4 text-ivory/30" data-id="element-64" />
                  </div>
                  <span className="text-ivory/50 text-lg font-light" data-id="element-65">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}